import { gsap } from 'gsap';
import Dropin from './Dropin';

export default class NewsletterDropin {
	constructor(newsletter) {
		this.newsletter = newsletter;
		if (this.newsletter.isSubscribed) {
			return;
		}

		this.elm = this.newsletter.newsletter;
		this.form = this.newsletter.form;

		// Dropin
		this.title = this.elm.querySelector('[data-newsletter-title]');
		this.isOpen = false;
		this.measurements = {
			desktop: 90,
			mobile: 76,
		};

		this.dropin = new Dropin(this.elm, document.querySelector('[data-barba="container"]'), this);
		document.addEventListener('bless', ({ detail }) => {
			if (this.dropin) {
				this.dropin.destroy();
			}
			this.closeAndHide();
			this.container = detail.next.container;
			if (this.newsletter.isSubscribed) {
				return;
			}
			this.dropin = new Dropin(this.elm, this.container, this);
		});

		this.elm.addEventListener('click', (e) => {
			this.open();
		});

		this.feedback = this.elm.querySelector('[data-newsletter-feedback]');

		document.addEventListener('click', (e) => {
			if (e.target && !e.target.closest('[data-newsletter]')) {
				if (this.elm) {
					this.close();
				}
			}
		});
	}

	getDevice() {
		const breakpoint = window.matchMedia('(max-width:575px)');

		if (breakpoint.matches === true) {
			return 'mobile';
		}

		return 'desktop';
	}

	show() {
		document.body.classList.add('body--newsletter-dropin');
	}

	hide() {
		if (this.isOpen) {
			return;
		}
		document.body.classList.remove('body--newsletter-dropin');
	}

	open() {
		if (this.isOpen || this.newsletter.success) {
			return;
		}

		this.elm.style.cursor = 'initial';

		const tl = gsap.timeline({
			onComplete: () => {
				this.isOpen = true;
				this.elm.querySelector('[type="email"]').focus();
				document.body.classList.add('has-newsletter-open');
			},
		});

		if (this.getDevice() == 'desktop') {
			tl.to(this.title, {
				autoAlpha: 0,
				duration: 0.3,
				ease: 'sine.inOut',
			});
			tl.to(
				this.elm,
				{
					targets: this.elm,
					width: 604,
					duration: 0.3,
					ease: 'sine.inOut',
				},
				'<',
			);
			tl.to(this.form, {
				opacity: 1,
				duration: 0.3,
				ease: 'sine.inOut',
			});
		} else {
			tl.to(this.title, {
				autoAlpha: 0,
				duration: 0.15,
				ease: 'sine.inOut',
			});

			tl.to(
				this.elm,
				{
					width: window.innerWidth,
					height: 294,
					borderRadius: 0,
					duration: 0.3,
					ease: 'sine.inOut',
				},
				'<',
			);

			tl.to(
				this.elm,
				{
					right: 0,
					bottom: 0,
					duration: 0.05,
					ease: 'sine.inOut',
				},
				'<+=0.15',
			);

			tl.to(this.form, {
				opacity: 1,
				duration: 0.3,
				ease: 'sine.inOut',
			});
		}
	}

	close() {
		return new Promise((resolve, reject) => {
			if (!this.isOpen) {
				resolve();
				return;
			}

			const device = this.getDevice();
			const tl = gsap.timeline({
				onComplete: () => {
					this.elm.style.cursor = 'pointer';
					this.isOpen = false;
					this.isSubmitting = false;
					document.body.classList.remove('has-newsletter-open');

					if (this.newsletter.success) {
						this.elm.style.cursor = 'initial';

						gsap.to(this.feedback, {
							autoAlpha: 1,
							duration: 0.3,
							ease: 'sine.inOut',
							onComplete: () => {
								setTimeout(() => {
									this.hide();
								}, 2000);
							},
						});
					} else {
						gsap.to(this.title, {
							autoAlpha: 1,
							duration: 0.3,
							ease: 'sine.inOut',
							onComplete: () => {
								resolve();
							},
						});
					}
				},
			});

			tl.to(this.form, {
				opacity: 0,
				duration: 0.3,
				ease: 'sine.inOut',
			});

			if (device == 'desktop') {
				tl.to(this.elm, {
					width: this.measurements[device],
					duration: 0.3,
					ease: 'sine.inOut',
				});
			} else {
				tl.to(this.elm, {
					width: this.measurements[device],
					height: this.measurements[device],
					borderRadius: this.measurements[device] / 2,
					right: 14,
					bottom: 14,
					duration: 0.2,
					ease: 'sine.inOut',
				});
			}
		});
	}

	closeAndHide() {
		this.close().then(() => {
			this.hide();
		});
	}

	showAndOpen() {
		this.show();
		this.open();
	}
}
